<i18n src="@/common/i18n/i18n-locales.json"></i18n>
<i18n>
{
  "en": {
    "paymentAndInvoiceSettings": "Payment/Invoice Settings",
    "paymentAndReceiptSettings": "Payment/Receipt Settings",
    "paymentMethod": "Payment Method",
    "payOnline": "Pay online",
    "physicalCard": "Physical Card",
    "seeStaffToCompleteCheckout": "See staff to complete checkout",
    "physicalCardSeeStaffToCompleteCheckout": "Physical Card. See staff to complete checkout",
    "discount": "Discount {discount}% off",
    "mobilePhone": "Mobile Phone",
    "phoneNumber": "Phone Number",
    "invoiceCarrier": "Invoice Carrier / Donate",
    "clickToSelectInvoiceOptions": "Click to select invoice options",
    "taxId": "Tax ID:",
    "invoiceTitle": "Company Name:",
    "carrierId": "Carrier ID:",
    "pleaseEnter": "Please enter",
    "npoDonationId": "NPO Donation ID:",
    "pleaseEnterPhoneNumber": "For pre-order, please enter mobile number.",
    "totalPrice": "Total: $ {price}"
  },
  "zh-tw": {
    "paymentAndInvoiceSettings": "付款/發票設定",
    "paymentAndReceiptSettings": "付款/收據設定 (本店免開發票)",
    "paymentMethod": "付款方式",
    "payOnline": "手機線上付款",
    "physicalCard": "實體卡片",
    "seeStaffToCompleteCheckout": "請洽服務人員付款",
    "physicalCardSeeStaffToCompleteCheckout": "實體卡片，請洽服務人員付款",
    "discount": "優惠折扣 {discount}%",
    "mobilePhone": "手機",
    "phoneNumber": "手機號碼",
    "invoiceCarrier": "發票載具 / 捐贈",
    "clickToSelectInvoiceOptions": "按我設定發票",
    "taxId": "統一編號:",
    "invoiceTitle": "收據抬頭:",
    "carrierId": "載具 ID:",
    "pleaseEnter": "請輸入",
    "npoDonationId": "愛心碼:",
    "pleaseEnterPhoneNumber": "預約外帶請輸入手機號碼",
    "totalPrice": "總計 {price} 元"
  }
}
</i18n>

<template>
  <div>
    <!--
      載具：只有使用收銀機又開發票才能選
      統編：全部都可以，除了使用收銀機、而且載具不是紙本
      抬頭：只有開收據才能輸入抬頭
    -->
    <f7-card>
      <f7-card-header v-if="useReceipt">{{ $t(`paymentAndInvoiceSettings`) }}</f7-card-header>
      <f7-card-header v-else>{{ $t(`paymentAndReceiptSettings`) }}</f7-card-header>
      <f7-card-content style="padding: 5px;">
        <f7-list accordion-list style="margin: 0px;">
          <f7-list-item
            ref="paymentMethod"
            accordion-item
            :title="$t(`paymentMethod`)"
            :accordion-item-opened="currentFocusSetting === 'paymentMethod'"
            @accordion:opened="setFocus('paymentMethod')">
            <div v-if="paymentMethod" slot="after" style="color: gray;">
              <div style="display: flex; align-items: center; justify-content: flex-end;">
                <img v-if="paymentMethod === paymentMethodType.easyCard" src="@/assets/easyCard.png" class="paymentMethod-img" />
                <img v-else-if="paymentMethod === paymentMethodType.creditCard" src="@/assets/creditCard.png" class="paymentMethod-img" />
                <img v-else-if="paymentMethod === paymentMethodType.linePayOnline" src="@/assets/linePay.png" class="paymentMethod-img" />
                <img v-else-if="paymentMethod === paymentMethodType.chinaUnionPay" src="@/assets/chinaUnionPay.png" class="paymentMethod-img" />
                <img v-else-if="paymentMethod === paymentMethodType.jkos" src="@/assets/jkos.png" class="paymentMethod-img" />
                <img v-else-if="paymentMethod === paymentMethodType.cash" src="@/assets/cash.png" class="paymentMethod-img" />
                <span style="margin-left: 0.3rem">{{ $t(`paymentMethodType.${paymentMethod}`) }}</span>
                <span v-if="paymentMethodDiscount > 0" style="margin-left: .5rem;">{{ selectedPaymentDiscount }}</span>
              </div>
              <div v-if="paymentMethodDiscount > 0" style="text-align: right">
                <discount-price :showTitle="false" :totalPrice="totalPrice" :discount="paymentMethodDiscount"></discount-price>
              </div>
            </div>
            <span v-else slot="after" style="color: red;">{{ $t(`instruction.pleaseSelect`) }}</span>
            <f7-accordion-content>
              <f7-list media-list style="margin-left: 15px;">
                <f7-list-item
                  v-if="store.acceptEasyCard && isPayOnlyLinePay===false"
                  radio
                  :title="$t(`paymentMethodType.easyCard`)"
                  :checked="paymentMethod === paymentMethodType.easyCard"
                  @click="selectPaymentMethod(paymentMethodType.easyCard, store.payDiscount.acceptEasyCard)">
                  <img slot="media" src="@/assets/easyCard.png" style="width: 36px;" />
                  <div slot="text" v-if="useCashier">{{ $t(`physicalCard`) }}</div>
                  <div slot="text" v-else>{{ $t(`physicalCardSeeStaffToCompleteCheckout`) }}</div>
                  <div v-if="store.payDiscount && store.payDiscount.acceptEasyCard">
                    <discount-price :totalPrice="totalPrice" :discount="store.payDiscount.acceptEasyCard"></discount-price>
                  </div>
                </f7-list-item>
                <f7-list-item
                  v-if="store.acceptCreditCard && isPayOnlyLinePay===false"
                  radio
                  :title="$t(`paymentMethodType.creditCard`)"
                  :checked="paymentMethod === paymentMethodType.creditCard"
                  @click="selectPaymentMethod(paymentMethodType.creditCard, store.payDiscount.acceptCreditCard)">
                  <img slot="media" src="@/assets/creditCard.png" style="width: 36px;" />
                  <span slot="text">
                    <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 2px; align-items: center;">
                      {{ $t(`physicalCard`) }}&nbsp;&nbsp;
                      <img src="@/assets/mastercard.png" style="height: 12px; margin: 0px 2px; flex: 0;" />
                      <img src="@/assets/visa.png" style="height: 12px; margin: 0px 2px; flex: 0;" />
                      <img src="@/assets/jcb.png" style="height: 12px; margin: 0px 2px; flex: 0;" />
                    </div>
                    <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 2px; align-items: center;">
                      {{ $t(`mobilePhone`) }}&nbsp;&nbsp;
                      <img src="@/assets/applePay.png" style="height: 12px; margin: 0px 2px; flex: 0;" />
                      <img src="@/assets/googlePay.png" style="height: 12px; margin: 0px 2px; flex: 0;" />
                      <img src="@/assets/samsungPay.png" style="height: 12px; margin: 0px 2px; flex: 0;" />
                    </div>
                    <div v-if="!useCashier">{{ $t(`seeStaffToCompleteCheckout`) }}</div>
                  </span>
                  <div v-if="store.payDiscount && store.payDiscount.acceptCreditCard">
                    <discount-price :totalPrice="totalPrice" :discount="store.payDiscount.acceptCreditCard"></discount-price>
                  </div>
                </f7-list-item>
                <f7-list-item
                  v-if="store.acceptLinePayOnline"
                  radio
                  :title="$t(`paymentMethodType.linePayOnline`)"
                  :text="$t(`payOnline`)"
                  :checked="paymentMethod === paymentMethodType.linePayOnline"
                  @click="selectPaymentMethod(paymentMethodType.linePayOnline, store.payDiscount.acceptLinePayOnline)">
                  <img slot="media" src="@/assets/linePay.png" style="width: 36px;" />
                  <div v-if="store.payDiscount && store.payDiscount.acceptLinePayOnline">
                    <discount-price :totalPrice="totalPrice" :discount="store.payDiscount.acceptLinePayOnline"></discount-price>
                  </div>
                </f7-list-item>
                <f7-list-item
                  v-if="store.acceptCreditCard && isPayOnlyLinePay===false"
                  radio
                  :title="$t(`paymentMethodType.chinaUnionPay`)"
                  :checked="paymentMethod === paymentMethodType.chinaUnionPay"
                  @click="selectPaymentMethod(paymentMethodType.chinaUnionPay, store.payDiscount.acceptCreditCard)">
                  <img slot="media" src="@/assets/chinaUnionPay.png" style="width: 36px;" />
                  <div slot="text" v-if="useCashier">{{ $t(`physicalCard`) }}</div>
                  <div slot="text" v-else>{{ $t(`physicalCardSeeStaffToCompleteCheckout`) }}</div>
                  <div v-if="store.payDiscount && store.payDiscount.acceptCreditCard">
                    <discount-price :totalPrice="totalPrice" :discount="store.payDiscount.acceptCreditCard"></discount-price>
                  </div>
                </f7-list-item>
                <f7-list-item
                  v-if="store.acceptJkos && isPayOnlyLinePay===false"
                  radio
                  :title="$t(`paymentMethodType.jkos`)"
                  :checked="paymentMethod === paymentMethodType.jkos"
                  @click="selectPaymentMethod(paymentMethodType.jkos, store.payDiscount.acceptJkos)">
                  <img slot="media" src="@/assets/jkos.png" style="width: 36px;" />
                  <div slot="text" v-if="useCashier">{{ $t(`seeStaffToCompleteCheckout`) }}</div>
                  <div slot="text" v-else>{{ $t(`seeStaffToCompleteCheckout`) }}</div>
                  <div v-if="store.payDiscount && store.payDiscount.acceptJkos">
                    <discount-price :totalPrice="totalPrice" :discount="store.payDiscount.acceptJkos"></discount-price>
                  </div>
                </f7-list-item>
                <f7-list-item
                  v-if="store.acceptCash && isPayOnlyLinePay===false"
                  radio
                  :title="$t(`paymentMethodType.cash`)"
                  :text="$t(`seeStaffToCompleteCheckout`)"
                  :checked="paymentMethod === paymentMethodType.cash"
                  @click="selectPaymentMethod(paymentMethodType.cash, store.payDiscount.acceptCash)">
                  <img slot="media" src="@/assets/cash.png" style="width: 36px;" />
                  <div v-if="store.payDiscount && store.payDiscount.acceptCash">
                    <discount-price :totalPrice="totalPrice" :discount="store.payDiscount.acceptCash"></discount-price>
                  </div>
                </f7-list-item>
                <f7-list-item
                  v-if="store.acceptOthers && isPayOnlyLinePay===false"
                  radio
                  :title="$t(`paymentMethodType.others`)"
                  :text="$t(`seeStaffToCompleteCheckout`)"
                  :checked="paymentMethod === paymentMethodType.others"
                  @click="selectPaymentMethod(paymentMethodType.others, store.payDiscount.acceptOthers)">
                  <img slot="media" style="width: 36px;" />
                  <div v-if="store.payDiscount && store.payDiscount.acceptOthers">
                    <discount-price :totalPrice="totalPrice" :discount="store.payDiscount.acceptOthers"></discount-price>
                  </div>
                </f7-list-item>
              </f7-list>
            </f7-accordion-content>
          </f7-list-item>

          <f7-list-item
            ref="receiptCarrier"
            v-if="useCashier && useReceipt"
            accordion-item
            :title="$t(`invoiceCarrier`)"
            :accordion-item-opened="currentFocusSetting === 'receiptCarrier'">
            <span v-if="receiptCarrier" slot="after" style="color: gray;">{{ $t(`receiptCarrierType.${receiptCarrier}`) }}</span>
            <span v-else slot="after" style="color: red;">{{ $t(`clickToSelectInvoiceOptions`) }}</span>
            <f7-accordion-content>
              <f7-list media-list style="margin-left: 15px;">
                <f7-list-item
                  radio
                  :title="$t(`receiptCarrierType.paper`)"
                  :checked="receiptCarrier === receiptCarrierType.paper"
                  @click="selectReceiptCarrier(receiptCarrierType.paper)" />
                <!-- <f7-list-item
                  v-if="paymentMethod === paymentMethodType.easyCard"
                  radio
                  :title="$t(`receiptCarrierType.easyCard`)"
                  :checked="receiptCarrier === receiptCarrierType.easyCard"
                  @click="selectReceiptCarrier(receiptCarrierType.easyCard)" /> -->
                <f7-list-item
                  radio
                  :title="$t(`receiptCarrierType.barcode`)"
                  :checked="receiptCarrier === receiptCarrierType.barcode"
                  @click="selectReceiptCarrier(receiptCarrierType.barcode)" />
                <f7-list-item
                  radio
                  :title="$t(`receiptCarrierType.cdc`)"
                  :checked="receiptCarrier === receiptCarrierType.cdc"
                  @click="selectReceiptCarrier(receiptCarrierType.cdc)" />
                <f7-list-item
                  radio
                  :title="$t(`receiptCarrierType.donate`)"
                  :checked="receiptCarrier === receiptCarrierType.donate"
                  @click="selectReceiptCarrier(receiptCarrierType.donate)" />
              </f7-list>
            </f7-accordion-content>
          </f7-list-item>

          <f7-list-item
            v-if="!(useCashier && useReceipt && receiptCarrier !== receiptCarrierType.paper)"
            @click="taxId.length !== 8 ? $f7router.navigate(`/stores/${storeId}/order/tax-id-prompt`) : clearTaxId()"
            :title="$t(`taxId`)">
            <span slot="after" :style="isTaxIdValid ? {} : { color: 'red' }">
              <template v-if="taxId.length !== 0">{{ taxId }}</template>
              <font-awesome-icon v-if="taxId.length !== 8" style="margin: 0px -3px 0px 13px;" icon="edit" />
              <font-awesome-icon v-else style="margin-left: 15px;" icon="times" />
            </span>
          </f7-list-item>

          <f7-list-item
            v-if="!useReceipt"
            @click="invoiceTitle.length === 0 ? $f7router.navigate(`/stores/${storeId}/order/invoice-title-prompt`) : clearInvoiceTitle()"
            :title="$t(`invoiceTitle`)">
            <span slot="after">
              <template v-if="invoiceTitle.length !== 0">{{ invoiceTitle }}</template>
              <font-awesome-icon icon="edit" style="margin: 0px -3px 0px 13px;"/>
            </span>
          </f7-list-item>

          <f7-list-item
            v-if="receiptCarrier === receiptCarrierType.barcode || receiptCarrier === receiptCarrierType.cdc"
            @click="$f7router.navigate(`/stores/${storeId}/order/receipt-carrier-id-prompt`)"
            :title="$t(`carrierId`)">
            <span slot="after" :style="isReceiptCarrierIdValid ? {} : { color: 'red' }">
              <template v-if="receiptCarrierId.length !== 0">
                <template v-if="receiptCarrier === receiptCarrierType.barcode">/</template>
                {{ receiptCarrierId }}
              </template>
              <template v-else>{{ $t(`pleaseEnter`) }}</template>
              <font-awesome-icon icon="edit" style="margin: 0px -3px 0px 13px;"/>
            </span>
          </f7-list-item>

          <f7-list-item
            v-if="receiptCarrier === receiptCarrierType.donate"
            @click="$f7router.navigate(`/stores/${storeId}/order/receipt-carrier-id-prompt`)"
            :title="$t(`npoDonationId`)">
            <span slot="after" :style="isReceiptCarrierIdValid ? {} : { color: 'red' }">
              <template v-if="receiptCarrierId.length !== 0">{{ receiptCarrierId }}</template>
              <template v-else>{{ $t(`pleaseEnter`) }}</template>
              <font-awesome-icon icon="edit" style="margin: 0px -3px 0px 13px;"/>
            </span>
          </f7-list-item>
        </f7-list>
      </f7-card-content>
    </f7-card>

    <f7-card>
      <f7-card-content>
        <f7-list>
          <f7-list-item :title="$t(`pageTitle.diningPreference`)" @click="$f7router.navigate(`/stores/${storeId}/dining-preference`)">
            <span slot="after" :style="diningPreferenceStyle">
              {{ diningPreferenceFullString }}
              <font-awesome-icon icon="edit" style="margin: 0px 1px 0px 13px;"/>
            </span>
          </f7-list-item>
          <f7-list-item v-if="diningPreference === diningPreferenceType.preOrder" :title="$t(`phoneNumber`)" @click="$f7router.navigate(`/stores/${storeId}/order/phone-number-prompt`)">
            <span v-if="phoneNumber" slot="after" :style="isPhoneNumberValid ? {} : { color: 'red' }">{{ phoneNumber }}</span>
            <span v-else slot="after" style="color: red;">{{ $t(`pleaseEnterPhoneNumber`) }}</span>
            <font-awesome-icon icon="edit" style="margin: 0px 1px 0px 13px; font-size: 14px; color: #757575;"/>
          </f7-list-item>
        </f7-list>
      </f7-card-content>
    </f7-card>
  </div>
</template>

<script>
import DiscountPrice from './order-setting/DiscountPrice'
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'Order',
  dependencies: [
    'paymentMethodType',
    'receiptCarrierType',
    'diningPreferenceType'
  ],
  mounted () {
    if (this.isPayOnlyLinePay === true) {
      this.selectPaymentMethod(this.paymentMethodType.linePayOnline, this.store.payDiscount.acceptLinePayOnline)
    }
  },
  computed: {
    ...mapState([
      'store',
      'menuVariation',
      'paymentMethod',
      'paymentMethodDiscount',
      'receiptCarrier',
      'receiptCarrierId',
      'taxId',
      'invoiceTitle',
      'diningPreference',
      'tableNumber',
      'pickupTime',
      'phoneNumber'
    ]),
    ...mapGetters([
      'storeId',
      'useReceipt',
      'useCashier',
      'isReceiptCarrierIdValid',
      'isTaxIdValid',
      'isPhoneNumberValid',
      'isPayOnlyLinePay'
    ]),
    ...mapGetters('itemModule', ['subtotal', 'totalPrice']),
    currentFocusSetting () {
      if (!this.paymentMethod) {
        return 'paymentMethod'
      } else if (this.useReceipt && !this.receiptCarrier) {
        return 'receiptCarrier'
      } else if (this.useReceipt && this.receiptCarrier && !this.isReceiptCarrierIdValid) {
        return 'receiptCarrierId'
      }
      return null
    },
    selectedPaymentDiscount () {
      if (this.paymentMethodDiscount > 0) {
        return `(-${this.paymentMethodDiscount}%)`
      }
    },
    diningPreferenceStyle () {
      const styleString = {
        forHere: this.tableNumber ? {} : { color: 'red' },
        takeAway: {},
        preOrder: this.pickupTime ? {} : { color: 'red' }
      }
      return styleString[this.diningPreference]
    },
    diningPreferenceFullString () {
      const valueStrings = {
        forHere: this.tableNumber || '請選擇桌號',
        takeAway: '',
        preOrder: this.pickupTime ? moment(this.pickupTime).format('MM/DD HH:mm') : '請選擇取餐時間'
      }
      return this.$t(`diningPreferenceType.${this.diningPreference}`) + ' ' + valueStrings[this.diningPreference]
    }
  },
  methods: {
    ...mapActions([
      'setOrderParams',
      'setReceiptCarrierId',
      'setTaxId',
      'setInvoiceTitle',
      'setPaymentMethod',
      'setReceiptCarrier',
      'setPaymentMethodDiscount'
    ]),
    setFocus (field) {
      if (this.$refs[field]) {
        this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    },
    selectPaymentMethod (paymentMethod, paymentMethodDiscount) {
      this.$f7.accordion.close(this.$refs.paymentMethod.$el)
      this.setPaymentMethod(paymentMethod)
      this.setFocus(this.currentFocusSetting)
      this.setPaymentMethodDiscount(paymentMethodDiscount || 0) // 設定付款方法後 也要設定付款方法的折扣，若是折扣不存在則帶 0
    },
    selectReceiptCarrier (receiptCarrier) {
      this.$f7.accordion.close(this.$refs.receiptCarrier.$el)
      this.setReceiptCarrier(receiptCarrier)
      this.setFocus(this.currentFocusSetting)
    },
    clearTaxId () {
      this.setTaxId('')
    },
    clearInvoiceTitle () {
      this.setInvoiceTitle('')
    }
  },
  components: {
    DiscountPrice
  }
}
</script>

<style lang="scss">
// overwrite framework7 css
.md label.item-radio>.icon-radio {
  margin-right: 18px;
}

.paymentMethod-img {
  height: 18px;
}

</style>
